<template>
    <div class="card" v-on:click="onClick(lead.personId)">
        <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between;">
            <div>
                <div style="display: flex; flex-direction: row; gap: 5px; align-items: baseline ;">
                    <v-tooltip top v-if="lead.qualifiedAt" >
                        <v-icon small color="orange" slot="activator">fas fa-award</v-icon>
                        Qualificado
                    </v-tooltip>
                    <v-tooltip top v-if="lead.completedAt" >
                        <v-icon small color="green" slot="activator">fas fa-check-square</v-icon>
                        Fluxo finalizado
                    </v-tooltip>
                    <p class="lead-title">{{ lead.title }}</p>
                </div>
                <p class="name">
                    {{ lead.name }}
                    <v-tooltip top v-if="lead.representativeName || lead.representativeFederalId || lead.representativeBirth">
                        <v-icon slot="activator">fas fa-user-friends</v-icon>
                        Possui representante legal
                    </v-tooltip>
                </p>
            </div>
            <div class="card-options">
                <div class="card-edit" v-on:click="edit">
                    <v-icon>fas fa-pencil-alt</v-icon>
                    <div class="card-options-list">
                        <div :key="status.id" class="card-options-list-item" v-for="status in lead.offerLeadStatus.find(offerLeadStatus => offerLeadStatus.id == lead.semanticId).status" v-on:click="updateStatus(status.id, status.name)">{{ status.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="card-footer">
            <p class="lead-status">{{ lead.leadStatus }}</p>
            <p class="offer-status-at" :style="background">{{ date }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        lead: {
            type: Object,
            required: true
        },
        onClick: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            date: '',
            background: 'background: white;',
        }
    },

    mounted () {
        this.updateNow()
        setInterval(this.updateNow.bind(this) , 1000)
    },

  
    methods: {
        updateNow() {
            // TEMPORARY SUBTRACTING TIMEZONE OFFSET
            this.date = this.$moment(this.lead.offerStatusAt).fromNow();
            this.backgroundColor(this.$moment(Date.now()).diff(this.$moment(this.lead.offerStatusAt), 'hours'));
        },

        async updateStatus(id, statusName) {
            try {
                await this.$api.dataService.execute('offerLead/updateOfferLeadStatus', { offerLeadId: this.lead.id, offerLeadStatus: { id } });

                this.lead.offerStatusAt = Date.now();
                this.lead.leadStatus = statusName;
            } catch(e) {
                // TODO handle the error
            }
        },

        backgroundColor(hours) {
            let color;

            switch(hours) {
                case 0:
                    color = '#bfbfbf';
                    break;
                case 1:
                    color = '#B5B900';
                    break;
                case 2:
                    color = '#be0000';
                    break;
                default: 
                    color = '#be0000';
                    break;
            }

            this.background = `background-color: ${color};`
        },

        edit($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    },

    created() {
        this.updateNow();
    }
}
</script>

<style scoped>
    p {
        margin: 0;
    }

    .card {
        padding: 10px;
        margin: 10px;
        height: auto;
        transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
        color: #262626;
        cursor: pointer;
        background-color: var(--background-color);
        border-radius: 5px;
        user-select: none;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .card-options {
        /* position: absolute;
        top: 0;
        right: 0; */
    }

    .card-options-list {
        width: max-content;
        position: absolute;
        top: 25px;
        right: 0;
        background-color: var(--white-color);
        border-radius: 5px;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        box-shadow: 0 5px 20px 0 rgba(0,0,0, 0.15);
        z-index: 1000;
        opacity: 0;
        visibility: hidden;
    }

    .card-options-list-item {
        width: 100%;
        padding: 5px 10px;
        color: #262626;
        cursor: pointer;
        display: flex;
    }

    .card-options-list-item:hover {
        background-color: var(--primary-background-color);
    }

    .card-footer {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
    }

    .lead-title {
        color: #8f8f8f;
        font-size: 12px;
        margin-bottom: 5px;
    }

    .name {
        font-weight: bold;
        color: var(--primary-color);
    }

    .name i {
        font-size: 14px;
        margin-left: 3px;
        color: #A8A8A8;
    }

    .offer-status-at {
        padding: 2px 5px;
        font-size: 12px;
        color: #FFF;
        text-align: end;
        border-radius: 5px;
    }

    .card-edit {
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        /* top: 10px;
        right: 10px; */
        cursor: pointer;
        visibility: hidden;
        background-color: #FFF;
        box-shadow: 0 2px 20px 0 rgba(0,0,0, 0.15);
        border-radius: 5px;
    }

    .card-edit:hover {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .card-edit:hover .card-options-list {
        border-top-right-radius: 0;
    }

    .card-edit:hover .card-options-list {
        opacity: 1;
        visibility: visible;
    }

    .card-edit:hover {
        opacity: 1;
    }

    .card-edit:active {
        box-shadow: none;
    }

    .card:hover .card-edit {
        visibility: visible;
    }

    .card-edit i {
        font-size: 12px;
        transition: none;
    }

    .lead-status {
        font-size: 12px;
        /* background-color: white; */
        /* padding: 3px 10px; */
        /* border-radius: 20px; */
        color: #262626;
        /* margin-bottom: 5px; */
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/KanbanCard.vue